import { Icon, Stack, Text } from '@fluentui/react';
import { useStyles } from '../../../../index.styles';

// @ts-ignore
export const Add: React.FC<{
  onClick: () => void;
  id?: string;
  title: string;
}> = ({ onClick, id, title }) => {
  const styles = useStyles();
  return (
    <Stack
      horizontal
      id={id}
      verticalAlign="center"
      horizontalAlign="center"
      tokens={{ childrenGap: 10 }}
      className={styles.addNode}
      onClick={onClick}
    >
      <Icon iconName="Add" />
      <Text>{title ? title : 'Add title'}</Text>
    </Stack>
  );
};
